/**
 * Created by guga on 7/21/2016.
 */

 import { CompanyService }  from '../../services/company.service';
 import { AppDataService } from '../../services';
 import { TranslationService } from '../../services';


 export class JobBean {

    public _companyService : CompanyService;
    public _appData : AppDataService;
    public translate: TranslationService
    public group:string
    public name : string
    public kind: string
    public id: number
    public completed:boolean
    public completedDate=0
    public timer:number;
    public param
    public userParam

    public actionPt=0;
    public viewPt=0;
    public myActionPoint=0;
    public myViewPoint=0;
    public testActionPoint=0;
    public testViewPoint=0;
    public myPoint=0;

    public triggers;

    constructor (){
       this.group=""
       this.name =""
       this.actionPt=0;
       this.viewPt=0;
       this.myActionPoint=0;
       this.myViewPoint=0;
       this.testActionPoint=0;
       this.testViewPoint=0;
       this.kind=""
       this.id=0;
       this.completed=false;
       this.completedDate=0
       this.timer=0;
       this.param={}
       this.userParam={}
       this.viewPt=
       this.myPoint=0
       this.triggers={}
    }
    public setCompanyService(service){
        this._companyService=service;
    }
    public setAppData(service){
        this._appData=service;
    }
    public setTranslation(service){
        this.translate=service;
    }
    public toDB() {
      return {
      group : this.group, 
      name : this.name,
      actionPt: this.actionPt,
      viewPt:this.viewPt,
      myActionPoint: this.myActionPoint,
      myViewPoint: this.myViewPoint,
      testActionPoint: this.testActionPoint,
      testViewPoint: this.testViewPoint,
      kind: this.kind,  
      timer:this.timer,
      id: this.id,
      completed:this.completed,
      completedDate:this.completedDate,
      param:this.param,
      userParam:this.userParam,
      myPoint:this.myPoint,
      triggers:this.triggers
      }
    }
    public parse(val){
      this.group=val.group ? val.group : "";
      this.name=val.name ? val.name : "";
      this.viewPt = val.viewPt ? val.viewPt : 0
      this.timer=val.timer?val.timer :0
      this.kind=val.kind ? val.kind : "";
      this.id=val.id ? val.id : 0
      this.completed=val.completed ? val.completed : false
      this.completedDate=val.completedDate ? val.completedDate : 0
      this.param=val.param ? val.param : {}
      this.userParam=val.userParam ? val.userParam : {}
      this.triggers=val.triggers? val.triggers : {}

      this.actionPt=val.actionPt ? val.actionPt : 0,
      this.viewPt=val.viewPt ? val.viewPt : 0,
      this.myActionPoint=val.myActionPoint ? val.myActionPoint : 0,
      this.myViewPoint=val.myViewPoint ? val.myViewPoint :0,
      this.testActionPoint= val.testActionPoint ? val.testActionPoint : 0,
      this.testViewPoint= val.testViewPoint ? val.testViewPoint : 0
      this.myPoint=val.myPoint? val.myPoint : 0
    }
};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/quests/job.bean.ts